import { useTradingStyle } from "@/contexts/TradingStyleContext";

export default function DisclaimerFooter() {
  const ctx = useTradingStyle?.();
  const style = ctx?.style || "SWING";
  // Post-Alpaca migration: swing is real-time SIP too (was 15-min-delayed Polygon).
  const dataLabel =
    style === "INTRADAY"
      ? "Real-time SIP · Powered by Alpaca"
      : "Real-time SIP · Powered by Alpaca";
  return (
    <footer
      data-testid="disclaimer-footer"
      className="fixed bottom-0 left-0 right-0 z-40 h-8 bg-[#080B11]/95 backdrop-blur border-t border-[#1E293B] px-4 flex items-center justify-between mono text-[10px] tracking-wider uppercase"
    >
      <span className="text-slate-500">
        <span className="text-cyan-500">◆</span> QUANT SIGNAL PLATFORM · Quantitative analysis only · Not investment advice · No brokerage execution
      </span>
      <span
        data-testid="disclaimer-data-source"
        className="text-slate-600 hidden sm:inline"
      >
        {dataLabel}
      </span>
    </footer>
  );
}
